import React from 'react';
import { getAdminInfo } from '../../services/auth';
import './Header.css';

function Header({ onLogout }) {
  const adminInfo = getAdminInfo();

  return (
    <div className="admin-header">
      <h1>Admin-Panel</h1>
      <div className="admin-header-right">
        <span className="admin-name">{adminInfo?.name || adminInfo?.email || 'Admin'}</span>
        <button onClick={onLogout} className="btn btn-danger">
          Abmelden
        </button>
      </div>
    </div>
  );
}

export default Header;






